import React from 'react';
import { FaBolt, FaSearch, FaSun, FaMoon } from 'react-icons/fa';
import NotificationBell from '../NotificationBell';
import { UserData } from './types';
 
interface TopNavProps {
  darkMode: boolean;
  showExplore: boolean;
  userData: UserData;
  onToggleDarkMode: () => void;
  onToggleExplore: () => void;
  onProfileClick: () => void;
}
 
export const TopNav: React.FC<TopNavProps> = ({
  darkMode,
  showExplore,
  userData,
  onToggleDarkMode,
  onToggleExplore,
  onProfileClick,
}) => {
  return (
    <nav
      className="fixed top-0 left-0 right-0 border-b z-50 transition-colors"
      style={{
        background: darkMode ? 'rgba(13,26,26,0.97)' : 'rgba(240,250,250,0.97)',
        backdropFilter: 'blur(12px)',
        borderColor: darkMode ? 'rgba(90,184,184,0.15)' : 'rgba(13,26,26,0.1)',
      }}
    >
      <div className="px-6 py-3 flex items-center justify-between max-w-7xl mx-auto">
 
        {/* Wordmark */}
        <div className="flex items-center gap-3">
          <div
            className="w-9 h-9 rounded-lg flex items-center justify-center"
            style={{
              background: '#0d1a1a',
              border: '2px solid #0d1a1a',
              boxShadow: '2px 2px 0 rgba(13,26,26,0.4)',
            }}
          >
            <FaBolt style={{ color: '#7ecece', fontSize: '14px' }} />
          </div>
          <div>
            <h1
              className="font-black text-base leading-none"
              style={{
                fontFamily: "'Bebas Neue', sans-serif",
                letterSpacing: '4px',
                color: darkMode ? '#f0fafa' : '#0d1a1a',
              }}
            >
              RONYX
            </h1>
            <p
              className="text-[8px] tracking-widest"
              style={{ color: darkMode ? 'rgba(126,206,206,0.45)' : 'rgba(13,26,26,0.4)', marginTop: '-1px' }}
            >
              NETWORK
            </p>
          </div>
        </div>
 
        {/* Right actions */}
        <div className="flex items-center gap-2">
          {/* Search / Explore */}
          <button
            onClick={onToggleExplore}
            className="p-2 rounded-lg transition-all"
            style={{
              background: showExplore
                ? '#e8a820'
                : 'transparent',
              border: showExplore ? '2px solid #0d1a1a' : '2px solid transparent',
              boxShadow: showExplore ? '2px 2px 0 #0d1a1a' : 'none',
              color: showExplore ? '#0d1a1a' : darkMode ? '#5ab8b8' : '#3a9898',
            }}
          >
            <FaSearch style={{ fontSize: '15px' }} />
          </button>
 
          <NotificationBell />
 
          {/* Dark mode toggle */}
          <button
            onClick={onToggleDarkMode}
            className="p-2 rounded-lg transition-all"
            style={{ color: darkMode ? '#5ab8b8' : '#3a9898' }}
          >
            {darkMode
              ? <FaSun style={{ fontSize: '15px' }} />
              : <FaMoon style={{ fontSize: '15px' }} />
            }
          </button>
 
          {/* Avatar */}
          <button
            onClick={onProfileClick}
            className="p-1 rounded-lg transition-all"
            style={{ border: '2px solid rgba(90,184,184,0.4)' }}
          >
            <img
              src={userData.photoURL}
              alt={userData.username}
              className="w-7 h-7 rounded-full"
            />
          </button>
        </div>
      </div>
    </nav>
  );
};